import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LockProvider, useLock } from './context/LockContext';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import LockScreen from './components/LockScreen';
import { NotificationPrompt } from './components/NotificationPrompt';
import { usePushNotifications } from './hooks/usePushNotifications';
import OrdersPage from './pages/OrdersPage';
import LoginPage from './pages/LoginPage';
import NewPasswordPage from './pages/NewPasswordPage';
import { storage, migrateLocalStorageKeys } from './utils/storage';
import './App.css';

// Run one-time localStorage key migration (un-prefixed → comanda_ prefixed)
migrateLocalStorageKeys();

// Componente que maneja el lock screen dentro de las rutas protegidas
function ProtectedApp() {
  const [restaurantId, setRestaurantId] = useState(null);
  const { isLocked, hasPin } = useLock();
  const { user } = useAuth();

  // Obtener restaurantId de localStorage
  useEffect(() => {
    const getRestaurantId = () => {
      const id = storage.get('selectedRestaurantId');
      setRestaurantId(id);
    };
    getRestaurantId();
    window.addEventListener('storage', getRestaurantId);
    return () => window.removeEventListener('storage', getRestaurantId);
  }, []);

  // Hook de Push Notifications
  const pushNotifications = usePushNotifications(restaurantId, user?.userId);

  return (
    <>
      {(isLocked || !hasPin) ? (
        <LockScreen />
      ) : (
        <div className="App">
          {/* Prompt de notificaciones push */}
          <NotificationPrompt
            isSupported={pushNotifications.isSupported}
            isSubscribed={pushNotifications.isSubscribed}
            permission={pushNotifications.permission}
            isLoading={pushNotifications.isLoading}
            error={pushNotifications.error}
            onSubscribe={pushNotifications.subscribe}
          />
          <Routes>
            <Route path="/" element={<OrdersPage />} />
          </Routes>
        </div>
      )}
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <LockProvider>
            <Router basename="/resto/comanda">
              <Routes>
                {/* Rutas públicas */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/new-password" element={<NewPasswordPage />} />

                {/* Rutas protegidas */}
                <Route
                  path="/*"
                  element={
                    <ProtectedRoute>
                      <ProtectedApp />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </Router>
          </LockProvider>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
